<sw-modal
    :title="modalTitle"
    @modal-close="onCancel"
>
    <sw-text-field
        v-model="entity.searchTerm"
        required
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-filter-map.labelSearchTerm')"
        :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-filter-map.placeholderSearchTerm')"
    ></sw-text-field>

    <sw-text-field
        v-model="entity.blockedTerm"
        required
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-filter-map.labelBlockedTerm')"
        :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-filter-map.placeholderBlockedTerm')"
    ></sw-text-field>

    <template #modal-footer>
        <sw-button size="small" @click="onCancel">
            {{ $tc('global.default.cancel') }}
        </sw-button>
        <sw-button variant="primary" size="small" @click="onSave" :isLoading="isLoading">
            {{ $tc('global.default.save') }}
        </sw-button>
    </template>
</sw-modal>